import * as types from "../types/single-campaign";
import { call, put, takeEvery, all } from "redux-saga/effects";

function* fetchSingleCampaignDetails(action) {
  /*
    try{
        const details = yield call(retrieveContactListDetails, action.payload)
        if(details.error === null && details.payload){
            yield put({type: types.SET_SINGLE_CONTACT_LIST_DETAILS, details: details.payload})
        } else {
            throw new Error("Kunne ikke hente detaljer.")
        }
    } catch(e) {
        yield put({type: types.REVOKE_SINGLE_CONTACT_LIST_DETAILS, message: "Kunne ikke hente detaljer."})
    }
    */
}

function* singleCampaignSaga() {
  yield all([
    //takeEvery(types.REQUEST_SINGLE_CONTACT_LIST_DETAILS, fetchSingleCampaignDetails),
  ]);
}

export default singleCampaignSaga;
